import { render } from "./SectionTextEditBar.vue?vue&type=template&id=5c1d64da"
import script from "./SectionTextEditBar.vue?vue&type=script&lang=js"
export * from "./SectionTextEditBar.vue?vue&type=script&lang=js"

import "./SectionTextEditBar.vue?vue&type=style&index=0&id=5c1d64da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__